<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Facturas</h2>
        </span>
        <span class="pull-right pt-1 pb-4 pr-1">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1"
            (click)="openNewBDocumentModal('INVOICE')">
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nueva Factura</span>
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2 mr-1"
            (click)="openNewBDocumentFromTasksModal()">
            <i class="material-icons">paid</i>&nbsp;<span class="d-none d-sm-inline">Generar Factura Desde
              Servicios</span>
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2 mr-3"
            (click)="openNewBDocumentFromServiceAgreements()">
            <i class="material-icons">paid</i>&nbsp;<span class="d-none d-sm-inline">Generar Factura Desde
              Contrato</span>
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2 mr-3"
            (click)="openModalGenerateZip()">
            <i class="material-icons">folder_zip</i>&nbsp;<span class="d-none d-sm-inline">Descargar</span>
          </button>
        </span>
        <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

          <thead class="text-lavuro">
            <tr>

              <!-- All -->
              <!-- <th class="p-0 pl-2">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                            [checked]="selection.all">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </th> -->

              <!-- PC -->
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                N°<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.number" placeholder="Buscar por N°…"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                style="height: 65px; position: relative; max-width: 1000px;">
                Estado<br> <br>
                <select class="filter small" [(ngModel)]="filter.filters.status" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" width="200px"
                  style="margin-top: 10px; max-width: 1000px; position: absolute; top: 29px; left: 0px;">
                  <option *ngFor="let key of invoiceFilterOptionsKeys" [ngValue]="key">
                    {{invoiceStatusesLabels[key]}}
                  </option>
                  <option [ngValue]="undefined"> Todos </option>
                </select>
              </th>
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                width="150px">
                Fecha Emisión<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
              </th>
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                width="150px">
                Fecha Vto.<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dueDateStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dueDateEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
              </th>
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                style="height: 65px; position: relative; max-width: 1000px;">
                Total<br>
                <input type="number" class="filter small" [(ngModel)]="filter.filters.totalMin"
                  placeholder="Monto mínimo…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px; " /><br>
                <input type="number" class="filter small" [(ngModel)]="filter.filters.totalMax"
                  placeholder="Monto máximo…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px; " />
              </th>

              <!--th class="d-none d-md-table-cell align-top" width="1%"
                      style="height: 65px; position: relative; max-width: 1000px;">
                      Borrada?<br> <br>
                      <select class="filter small" [(ngModel)]="isCurrent" (ngModelChange)="lazySearch()"
                        (click)="$event.stopPropagation()"
                        style="margin-top: 10px; max-width: 60px; position: absolute; top: 27px; left: 10px;">
                        <option [ngValue]="false"> no </option>
                        <option [ngValue]="true"> si </option>
                        <option [ngValue]="undefined"> todos </option>
                      </select>
                    </th-->

              <!-- All -->
              <th class="td-actions text-right p-0"
                [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}" width="1%">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                            <span>Filtros</span>
                          </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let document of documents">
              <tr [class.text-danger]="document.isDeleted || document.status == invoiceStatuses.CANCELLED"
                class='cursor-pointer' (click)="openEditDocument(document)">

                <!-- All -->
                <!-- <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                      <div class="form-check m-0 mx-2">
                        <label class="form-check-label">
                          <input class="form-check-input input-sm" type="checkbox"
                            (click)="toggleSelection(document._id)"
                            [checked]="selection.all || selection[document._id]">
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                    </td> -->

                <!-- PC -->
                <td [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                  {{ document.serie != invoiceStatuses.DRAFT ? document.serieAndNumber || document.docNumber :
                  "" }}
                </td>
                <td class=" p-1 " [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                  width="200px">
                  <div class="text-center py-1 status-pill text-white"
                    [ngStyle]="{'background-color': invoiceStatusesColors[document.status] || invoiceStatusesColors.ISSUED}">
                    <!-- [class.text-white]="document.isDeleted || document.status == invoiceStatuses.CANCELLED"> -->
                    {{invoiceStatusesLabels[document.status] || invoiceStatusesLabels.ISSUED}}
                  </div>
                </td>
                <td class=" bold-item"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                  {{document.client.firstname}} {{document.client.lastname}}
                </td>
                <td class="l text-center"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}" width="150px">
                  {{document.date | date:'dd/MM/yyyy'}}</td>
                <td class=" text-center"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}" width="150px">
                  {{document.dueDate | date:'dd/MM/yyyy'}}
                  <span *ngIf="document.overdue"><b class="overdue">&nbsp;Vencida</b></span>
                </td>
                <td class="bold-item text-right"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">{{document.total |
                  money: { needSymbol:true } }}
                  &nbsp;&nbsp;</td>

                <!--td class="d-none d-md-table-cell">
                      <span *ngIf="!document.isDeleted">No</span>
                      <span *ngIf="document.isDeleted">Si</span>
                    </td-->

                <!-- Mobile -->
                <td [ngClass]="{'d-none': isGreaterThan672px(), 'd-table-cell': !isGreaterThan672px()}"
                  style="line-height: 14px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-8 col-sm-6">
                        <div class="row mb-2">
                          <b class="bold-item">
                            {{document.serie != invoiceStatuses.DRAFT ? "#" + (document.serieAndNumber ||
                            document.docNumber) :
                            "" }} <br *ngIf="document.serie != invoiceStatuses.DRAFT">
                          </b>
                        </div>
                        <div class="row mb-2">
                          {{document.client.firstname}} {{document.client.lastname}}
                        </div>
                        <div class="row mb-2">
                          fch:{{document.date | date:'dd/MM/yyyy'}}
                        </div>
                        <div class="row">
                          Vto:{{document.dueDate | date:'dd/MM/yyyy'}}
                        </div>
                      </div>
                      <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row mb-2">
                          {{document.total | money: { needSymbol:true } }}
                        </div>
                        <div class="row mb-2">
                          <div class="text-center"
                            style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                            [ngStyle]="{'background-color': invoiceStatusesColors[document.status] || invoiceStatusesColors.ISSUED}"
                            [class.text-white]="document.isDeleted || document.status == invoiceStatuses.CANCELLED">
                            {{invoiceStatusesLabels[document.status] || invoiceStatusesLabels.ISSUED}}
                          </div>
                        </div>
                        <div class="row">
                          <b class="overdue" *ngIf="document.overdue">Vencida</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <!-- All -->
                <td class="td-actions text-right p-0" width="1%">
                  <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                    [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #menu="matMenu">

                    <button mat-menu-item (click)="openEditDocument(document)">
                      <span>Abrir</span>
                    </button>

                    <button mat-menu-item (click)="openDocument(document)">
                      <span>Ver PDF</span>
                    </button>

                    <button mat-menu-item (click)="download(document)"
                      *ngIf="(document.status == invoiceStatuses.ISSUED) || (document.status == invoiceStatuses.PAID) || (document.status == invoiceStatuses.DRAFT)">
                      <span>Descargar Factura</span>
                    </button>
                    <button mat-menu-item (click)="sendEmail(document)"
                      *ngIf="(document.status == invoiceStatuses.ISSUED) || (document.status == invoiceStatuses.PAID)">
                      <span>Enviar Factura por email</span>
                    </button>

                    <button mat-menu-item (click)="openDeleteBillingDocConfirm(document)"
                    *ngIf="(document.status == invoiceStatuses.DRAFT)">
                    <span>Eliminar</span>
                    </button>

                    <button mat-menu-item (click)="downloadReceipt(document)"
                      *ngIf="(document.status == invoiceStatuses.PAID)">
                      <span>Descargar Recibo</span>
                    </button>
                    <button mat-menu-item (click)="openUnderConstructionDialog()"
                      *ngIf="(document.status == invoiceStatuses.PAID)">
                      <span>Enviar Recibo por email</span>
                    </button>

                    <button mat-menu-item (click)="setPaidInvoice(document)"
                      *ngIf="(document.status == invoiceStatuses.ISSUED)">
                      <span>Registrar Pago</span>
                    </button>
                    <button mat-menu-item (click)="removePaymentsInvoice(document)"
                      *ngIf="(document.status == invoiceStatuses.PAID)">
                      <span>Eliminar Pago</span>
                    </button>

                    <button mat-menu-item (click)="openCorrectiveInvoiceModal(document)"
                      *ngIf="(document.status == invoiceStatuses.ISSUED || document.status == invoiceStatuses.PAID) && !document.correctiveInvoice">
                      <span>Rectificar</span>
                    </button>
                  </mat-menu>
                </td>
              </tr>

              <tr *ngIf="document.correctiveInvoice" class="cursor-pointer mt-0 pt-0"
                style="text-decoration: italic; color: purple" (click)="openCorrectiveInvoiceModal(document, true)">
                <td colspan="3" style="border-top: none" class="mt-0 pt-0"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                  Rectificada por Factura Nro:
                  {{ document.correctiveInvoice.serie }}-0000{{ document.correctiveInvoice.number }}
                </td>
                <td class="l text-center mt-0 pt-0" style="border-top: none"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}" width="150px">
                  {{ document.correctiveInvoice.date | date:'dd/MM/yyyy' }}
                </td>
                <td style="border-top: none">
                  &nbsp;
                </td>
                <td class="bold-item text-right mt-0 pt-0" style="border-top: none; padding-right: 17px"
                  [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}">
                  {{ document.correctiveInvoice.total | money: { needSymbol:true } }}
                </td>
                <td [ngClass]="{'d-none': isGreaterThan672px(), 'd-table-cell': !isGreaterThan672px()}"
                  style="line-height: 14px;">
                  Rectificada por Factura Nro: <br>
                  {{ document.correctiveInvoice.serie }}-0000{{ document.correctiveInvoice.number }} <br>
                  {{ document.correctiveInvoice.date | date:'dd/MM/yyyy' }} <br>
                  {{ document.correctiveInvoice.total | money: { needSymbol:true } }}
                </td>
                <td class="td-actions text-right p-0" width="1%">
                  <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                    [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #menu="matMenu">

                    <button mat-menu-item (click)="openCorrectiveInvoiceModal(document, true)">
                      <span>Abrir</span>
                    </button>

                    <button mat-menu-item (click)="openCorrectiveInvoiceModal(document)">
                      <span>Modificar</span>
                    </button>

                    <button mat-menu-item (click)="openDocumentCI(document)" *ngIf="(document.correctiveInvoice)">
                      <span>Ver PDF</span>
                    </button>
                    <button mat-menu-item (click)="downloadCI(document)" *ngIf="(document.correctiveInvoice)">
                      <span>Descargar</span>
                    </button>
                    <button mat-menu-item (click)="sendEmailCI(document)" *ngIf="(document.correctiveInvoice)">
                      <span>Enviar por email</span>
                    </button>
                  </mat-menu>
                </td>
              </tr>
            </ng-container>

            <!-- All  -->
            <tr *ngIf=" thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>
                  + cargar mas
                </button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">
                <div class="row">
                  <div class="col-12 col-md-3">
                    <span class="bold-item text-purple-manax">&nbsp;Mostrando: {{ documents?.length }} facturas</span>
                  </div>
                  <div class="col-12 col-md-3">
                    <span class="text-purple-manax">&nbsp;Subtotal: {{subtotals | money: { needSymbol:true } }}</span>
                  </div>
                  <div class="col-12 col-md-3">
                    <span class="text-purple-manax">&nbsp;Impuestos: {{taxes | money: { needSymbol:true } }}</span>
                  </div>
                  <div class="col-12 col-md-3">
                    <span class="bold-item text-purple-manax">&nbsp;Total: {{totals | money: { needSymbol:true } }}</span>
                  </div>
                  <div class="col-0 col-md-0">

                  </div>
                </div>
                <!-- <span class="bold-item">Mostrando: {{ documents?.length }} facturas.</span>&nbsp;&nbsp;
                <span>&nbsp;Subtotal: {{subtotals | money: { needSymbol:true } }},</span>&nbsp;&nbsp;
                <span>&nbsp;Impuestos: {{taxes | money: { needSymbol:true } }},</span>&nbsp;&nbsp;
                <span class="bold-item">&nbsp;Total: {{totals | money: { needSymbol:true } }}</span> -->
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>